import {
    createColumnDate,
    createColumnInput,
    createColumnInputNumber,
    createColumnSelect,
    // createColumnTreeSelect
} from "../../../../../components/table/c-table.logic";
import i18n from "../../../../../i18n";
import { putField } from "../../../../../utils/form";
// import { callRequestDepartment } from "../../../storage-location/request/requestor/requestor.section";
import { callDocumentStatus } from "../../../storage-location/storage-location/storage-location.section";
import store from "../../../../../store";
import moment from "moment";

export const callHazMgtType = ({ searchQuery }) =>
    store
        .dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "HAZ_MGT_TYPE", value: searchQuery })

export const createColumns = () => {
    const columns = [
        createColumnInput({
            title: () => i18n.global.t("views.report.docType"),
            dataIndexValue: () => i18n.global.t("views.report.hazMgtSellBuy"),
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            align: "center",
            search: { visible: () => false }
        }),
        createColumnInput({
            title: () => i18n.global.t("views.sellBuy.seller"),
            dataIndex: "refFrom.companyNameTh",
            dataIndexValue: ({ record }) => (record.refFrom?.refPersonType?.key === "1" ? record.refFrom?.companyNameTh : record.refFrom?.fullNameTh),
            customRender: ({ record, column }) => column.dataIndexValue({ record })
        }),
        createColumnInput({
            title: () => i18n.global.t("views.sellBuy.buyer"),
            dataIndex: "refTo.companyNameTh",
            dataIndexValue: ({ record }) => (record.refTo?.refPersonType?.key === "1" ? record.refTo?.companyNameTh : record.refTo?.fullNameTh),
            customRender: ({ record, column }) => column.dataIndexValue({ record })
        }),
        createColumnInput({
            title: () => i18n.global.t("model.hazMgtStorageLocation.refHaz"),
            dataIndex: "storageLocations.0.refHaz.approveCode",
            align: "center",
        }),
        createColumnInput({ title: () => i18n.global.t("model.haz.tradeNameTh"), dataIndex: "storageLocations.0.refHaz.tradeNameTh" }),
        createColumnInput({
            title: () => i18n.global.t("model.hazMgtStorageLocationStore.refStorageLocation"),
            dataIndex: "storageLocations.0.stores.0.refStorageLocation.name"
        }),
        createColumnInput({
            title: () => i18n.global.t("model.hazMgtStorageLocationStore.refStorageLocationSub"),
            dataIndex: "storageLocations.0.stores.0.refStorageLocationSub.buildingName"
        }),
        createColumnDate({
            title: () => i18n.global.t("views.sellBuy.sellDateTime"),
            dataIndex: "firstStatus.wait.0.statusDatetime",
            dataIndexValue: ({ record }) => moment(record.firstStatus?.wait?.[0]?.statusDatetime).format("YYYY-MM-DD"),
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            search: {
                name: "statuses.statusDatetime",
                type: "Datetime",
                operator: "between",
                getValue: ({ value }) => moment(value[0] + "T00:00:00").format("YYYY-MM-DD[T]HH:mm:ssZ"),
                getValue2: ({ value }) => moment(value[1] + "T23:59:59").format("YYYY-MM-DD[T]HH:mm:ssZ")
            }
        }),
        createColumnDate({ title: () => i18n.global.t("views.report.docEffectiveDate"), dataIndex: "effectiveDate", align: "center" }),
        createColumnInput({
            title: () => `เลขที่อ้างอิง${i18n.global.t("views.sellBuy.refInform")}`,
            dataIndex: "storageLocations.0.refStorageLocationSubItem.refInformProductQty.refInformProduct.refInform.approveCode"
        }),
        createColumnInputNumber({
            title: () => i18n.global.t("model.hazMgtStorageLocation.amount"),
            dataIndex: "storageLocations.0.amount",
            align: "center",
            search: { visible: () => false }
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.hazMgt.refType"),
            dataIndex: "refType.value",
            inputProp: () => ({ list: callHazMgtType, optLabel: "value" }),
            search: { visible: () => true, name: "refType.id" }
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.haz.refStatus"),
            dataIndex: "refStatus.value",
            inputProp: () => ({ list: callDocumentStatus, optLabel: "value" }),
            search: { name: "refStatus.id" },
            align: "center"
        })
    ];
    return columns;
};

export const createField = ({ data }) => {
    return putField({
        data,
        fields: []
    });
};
